import { render } from "./HeroiconsOutlineUserRemove.vue?vue&type=template&id=ea7cb518"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserRemove.vue"]])

export default __exports__